import React from 'react';
import { useOpenLDAPTranslation } from '../../i18n/hooks/useOpenLDAPTranslation';
import OpenLDAPHeader from './header/OpenLDAPHeader';
import OpenLDAPHero from './hero/OpenLDAPHero';
import OpenLDAPFeatures from './features/OpenLDAPFeatures';
import OpenLDAPBenefits from './benefits/OpenLDAPBenefits';

const OpenLDAPSection = () => {
  const { getOpenLDAPTranslation } = useOpenLDAPTranslation();
  const translation = getOpenLDAPTranslation();

  return (
    <div id="openldap" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <OpenLDAPHeader 
          title={translation.title}
          subtitle={translation.subtitle}
        />
        <div className="mt-16">
          <OpenLDAPHero {...translation.hero} />
        </div>
        <div className="mt-20">
          <OpenLDAPFeatures {...translation.features} />
        </div>
        <div className="mt-20">
          <OpenLDAPBenefits {...translation.benefits} />
        </div>
      </div>
    </div>
  );
};

export default OpenLDAPSection;